import store from '../store';
import { executeOnceInTime } from '@/services/utility';
import { Geolocation } from '@capacitor/geolocation';
import { LocalNotifications } from '@capacitor/local-notifications';

const updatePositionThrottle = executeOnceInTime((pos) => {
    console.log('updatePositionThrottle', pos);
    store.dispatch('geolocation/updatePosition', pos);
}, 1000 * 15);

export class NavigatorGeolocation {
    constructor () {
        this.available = true;
        this._id = null;
        this.first = true;
    }

    isAvailable () {
        return this.available;
    }

    async requestPermissionsForBackground () {
        const { granted } = await LocalNotifications.requestPermissions();
        return granted;
    }

    async requestPermissions () {
        const permissions = await Geolocation.requestPermissions();
        return permissions;
    }

    async once () {
        try {
            const coordinates = await Geolocation.getCurrentPosition();
            return coordinates;
        } catch (error) {
            console.log('location error', error);
            store.commit('geolocation/LOCATION_ENABLED_SET', false);
        }
    }

    async watch (options) {
        let self = this;
        if (this._id >= 0) {
            this.clear(this._id);
        }
        console.log('watch function ', options);
        this._id = await Geolocation.watchPosition(options, (position) => {
            if (self.first) {
                console.log('loggin first position', position);
                self.first = false;
            }
            store.commit('geolocation/LOCATION_ENABLED_SET', true);
            let pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            // store.commit('geolocation/SET_POSITION', pos);
            // store.dispatch('geolocation/updatePosition', pos);
            updatePositionThrottle(pos);
        });

        // , (error) => {
        //     console.log('location error', error);
        //     if (error.code === 2) {
        //         store.commit('geolocation/PERMISION_SET', true);
        //         // no tengo permisos
        //         window.navigator.geolocation.getCurrentPosition((position) => {
        //             console.log('forced to ask permission');
        //             self.watch();
        //         }, (error) => {
        //             console.log('error again', error);
        //         });
        //     }
        //     console.log('LOCATION ENABLED SET >> false');
        //     store.commit('geolocation/LOCATION_ENABLED_SET', false);
        // });
    }

    async get () {
        try {
            const position = await Geolocation.getCurrentPosition({
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            });
            store.commit('geolocation/LOCATION_ENABLED_SET', true);
            let pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            // store.commit('geolocation/SET_POSITION', pos);
            store.dispatch('geolocation/updatePosition', pos);
        } catch (error) {
            console.log('location error', error);
            store.commit('geolocation/LOCATION_ENABLED_SET', false);
        }
    }

    clear () {
        if (this._id >= 0) {
            Geolocation.clearWatch(this._id);
            this._id = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/NavigatorGeolocation.js